var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclamationError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 10,
    height: 100,
    viewBox: "0 0 10 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "exclamation-error-a",
    width: 10,
    height: 80,
    x: 0,
    y: 0,
    rx: 5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "exclamation-error-c",
    width: 10,
    height: 10,
    x: 0,
    y: 0,
    rx: 5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "rotate(180 5 50)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 20)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "exclamation-error-b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#exclamation-error-a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F54250",
    xlinkHref: "#exclamation-error-a"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#CC313D",
    points: "62 -95 62 145 -63 145",
    mask: "url(#exclamation-error-b)"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#F54250",
    xlinkHref: "#exclamation-error-c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationError);
export default __webpack_public_path__ + "static/media/exclamation-error.e9f447ac672a016baf2b9cad2d0eed19.svg";
export { ForwardRef as ReactComponent };